function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1,
  y: 1,
  width: 32,
  height: 22,
  rx: 4,
  fill: "#F5F4FF",
  stroke: "#6F62FF",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.7401 16.1197C14.1041 16.1197 15.7121 14.7517 15.7121 11.7397H11.7521V12.9637H14.1161C14.1161 13.0357 14.0921 13.0957 14.0801 13.1557C13.8761 14.1757 12.9521 14.7877 11.7401 14.7877C10.1921 14.7877 9.00408 13.4557 9.00408 11.8837C9.00408 10.2877 10.1921 8.99174 11.7401 8.99174C12.4841 8.99174 13.1561 9.30374 13.6481 9.79574L14.7041 8.87174C13.9841 8.11574 12.9281 7.63574 11.7401 7.63574C9.37608 7.63574 7.52808 9.53174 7.52808 11.8837C7.52808 14.2117 9.37608 16.1197 11.7401 16.1197Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.1147 15.9997H18.5787V7.73174H17.1147V15.9997Z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.7049 9.03974V7.73174H20.6889V15.9997H22.1529V12.5917H24.9609V11.2837H22.1529V9.03974H25.7049Z",
  fill: "#6F62FF"
});

var SvgGif = function SvgGif(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 34 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGif, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gif.e30b2f8a.svg";
export { ForwardRef as ReactComponent };